import { ViewMore } from '../InventoryWidget/ViewMore/ViewMore';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useRedirect } from '../../../hooks/useRedirect';
const useStyles = makeStyles((theme) => ({
    footer: {
        width: '100%',
        height: 35,
        padding: '0px 10px',
        borderTop: '1px solid #CCCCCC',
        clear: 'both',
        fontSize: theme.font.size.mediumSmall,
        fontWeight: theme.font.weight.bold,
        textTransform: 'uppercase',
        textAlign: 'right',
        lineHeight: '35px',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        '& > a': {
            color: '#276700',
            textDecoration: 'underline',
        },
        '& > i': {
            color: '#276700',
            marginLeft: 5,
        },
    },
    viewMore: {
        '& button': {
            minWidth: 0,
            width: 'fit-content',
            color: '#276700',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            textDecoration: 'underline',
            cursor: 'pointer',
            paddingRight: 0,
            paddingBottom: 11,
            whiteSpace: 'nowrap',
        },
    },
}));
export const WidgetFooter = ({ link, viewMoreButtonIsDisabled, left, center }) => {
    const classes = useStyles();
    const viewMore = useRedirect(link);
    return (React.createElement("footer", { className: classes.footer },
        React.createElement("div", null, left),
        React.createElement("div", null, center),
        React.createElement("div", { className: classes.viewMore },
            React.createElement(ViewMore, { disabled: viewMoreButtonIsDisabled, viewMore: viewMore }))));
};
//# sourceMappingURL=WidgetFooter.js.map